import { api_domain } from '../../config'
import axios from 'axios'

const url = `${api_domain}api/brand`
const brand = {
    get(model){
        return axios({
            url: url,
            params:{ keyword: model.keyword, display: model.display },
            method:'GET',
        }).catch((e)=>{
            console.log('Catch error on get-brand\n', e.message)
            return { status: e.response.status }           
        })
    },
    create(payload){
        return axios({
            url: url,
            data:payload,
            method:'POST',
        }).catch((e)=>{
            console.log('Catch error on create-brand\n', e.message)
            return { status: e.response.status }           
        })
    },
    edit(payload){
        return axios({
            url: url+'/update',
            data:payload,
            method:'PUT',
        }).catch((e)=>{
            console.log('Catch error on edit-brand\n', e.message)
            return { status: e.response.status }           
        })
    },
    display(payload){
        return axios({
            url: url+'-display',
            data:payload,
            method:'POST',
        }).catch((e)=>{
            console.log('Catch error on display-brand\n', e.message)
            return { status: e.response.status }           
        })
    },
}

export default brand